import {
  AuditOutlined,
  DashboardOutlined,
  BookOutlined,
  SettingOutlined,
  ReconciliationOutlined,
} from "@ant-design/icons";
import { Flex } from "antd";

const header_height = 58;

export default function useNavMenu({ authenticationState }) {
  const NavMenu = [
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 8, height: header_height }}
        >
          <AuditOutlined style={{ marginRight: 12 }} />
          SOP
        </Flex>
      ),
      key: "SOP",
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 8, height: header_height }}
        >
          <DashboardOutlined style={{ marginRight: 8 }} />
          Dashboard
        </Flex>
      ),
      key: "Dashboard",
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <BookOutlined style={{ marginRight: 8 }} />
          Data Entry
        </Flex>
      ),
      key: "DataEntry",
      children: [
        { label: "Emission", key: "Emission" },
        { label: "Abatement", key: "Abatement" },
      ],
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <ReconciliationOutlined style={{ marginRight: 8 }} />
          Reports
        </Flex>
      ),
      key: "Reports",
      children: [
        { label: "GHG Report (GHG Protocol)", key: "GhgReport" },
        { label: "Summary Report", key: "SummaryReport" },
      ],
    },
    authenticationState.user_type < 5 && {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <SettingOutlined style={{ marginRight: 8 }} />
          Configuration
        </Flex>
      ),
      key: "Configuration",
    },
  ];

  return [NavMenu, header_height];
}
